import React, { Component } from 'react';

export class Status extends Component {
  render() {
    window.location.replace('https://status.tuffshed.com');
    return <div>Taking you to the Services Status Page...</div>
  }
}
